import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isAtmSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IAtmSearchForm): IAtmSearchPost | {} => {
  if (isAtmSearchFormEmpty(data) || data == undefined) { return {} };
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllAtms = async ( {data} : {data: IAtmSearchForm}): Promise<IGetAtm> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  const response = await axiosDefaultApi.post(`api/Search/Search/Atm?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetAtm;
};

type QueryFnType = typeof getAllAtms;

type UseGetAllAtmsOptions = {
  data: IAtmSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAtms = ({ data, config }: UseGetAllAtmsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAtms'],
    queryFn: () => getAllAtms({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των ATM.`, 500);
      setIsNotificationVisible(true);
      console.log(error);
    }
  });
};